import Experience from "../Experience"
import Environment from "./Environment.js"
import Tabela from "./Tabela.js"

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        
        // Wait for resources
        this.resources.on('ready', () =>
        {
            // Setup
            this.tabela = new Tabela()
            this.environment = new Environment()
        })
    }
}